import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1999507b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid py-4" }
const _hoisted_2 = { class: "page-header mb-4" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "d-flex align-items-center gap-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "header-title" }, "Modifier un devoir"),
  /*#__PURE__*/_createElementVNode("p", { class: "header-subtitle" }, "Mettez à jour les informations de votre devoir")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "loading-text mt-3" }, "Chargement...", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "modern-card"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row g-4" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label-modern" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode(" Date de soumission ")
], -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label-modern" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Composition ")
], -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "detail-card mt-4"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle me-2" }),
  /*#__PURE__*/_createTextVNode(" Détails de la composition ")
], -1))
const _hoisted_24 = { class: "detail-body" }
const _hoisted_25 = { class: "row g-3" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "detail-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Matière", -1))
const _hoisted_29 = { class: "detail-value" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "detail-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Filière", -1))
const _hoisted_33 = { class: "detail-value" }
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = { class: "detail-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Niveau", -1))
const _hoisted_37 = { class: "detail-value" }
const _hoisted_38 = { class: "file-current-section mt-4" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-current-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf-o me-2 text-danger" }),
  /*#__PURE__*/_createTextVNode(" Fichier actuel ")
], -1))
const _hoisted_40 = { class: "file-current-body" }
const _hoisted_41 = { class: "file-current-info" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-paperclip me-2" }, null, -1))
const _hoisted_43 = { class: "file-current-actions" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye me-1" }, null, -1))
const _hoisted_45 = { class: "upload-section mt-4" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label-modern" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cloud-upload me-2" }),
  /*#__PURE__*/_createTextVNode(" Remplacer par un nouveau fichier PDF ")
], -1))
const _hoisted_47 = {
  key: 0,
  class: "upload-placeholder"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cloud-upload fa-3x text-primary mb-3" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cliquez pour sélectionner un nouveau fichier PDF")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted small" }, "ou glissez-déposez votre fichier ici", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted small" }, "Taille maximale : 20 Mo", -1))
const _hoisted_52 = [
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = {
  key: 1,
  class: "file-preview"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf-o fa-3x text-danger mb-2" }, null, -1))
const _hoisted_55 = { class: "mb-1" }
const _hoisted_56 = { class: "text-muted small" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash me-1" }, null, -1))
const _hoisted_58 = { class: "action-buttons mt-4" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_61 = {
  key: 1,
  class: "fa fa-save me-2"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times me-2" }, null, -1))
const _hoisted_63 = {
  key: 2,
  class: "alert alert-danger alert-modern mb-4"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle" })
], -1))
const _hoisted_65 = { class: "alert-content" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "alert-title" }, "Modification impossible", -1))
const _hoisted_67 = { class: "alert-message" }
const _hoisted_68 = { class: "modal-dialog-pdf" }
const _hoisted_69 = { class: "modal-content-modern" }
const _hoisted_70 = { class: "modal-header-pdf" }
const _hoisted_71 = { class: "modal-title" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf-o me-2" }, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { class: "modal-body-pdf" }
const _hoisted_76 = ["src"]
const _hoisted_77 = { class: "modal-footer-pdf" }
const _hoisted_78 = ["href"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-external-link me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/mes-devoirs",
            class: "btn-back-modern"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6
        ])
      ])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Form, {
              ref: "devoirForm",
              onSubmit: _ctx.updateDevoir,
              "validation-schema": _ctx.devoirSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("input", {
                        type: "text",
                        class: "form-control-modern",
                        value: _ctx.formatDate(_ctx.devoir?.dateSoumission),
                        disabled: ""
                      }, null, 8, _hoisted_17)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("input", {
                        type: "text",
                        class: "form-control-modern",
                        value: _ctx.devoir?.composition?.titre,
                        disabled: ""
                      }, null, 8, _hoisted_21)
                    ])
                  ])
                ]),
                (_ctx.devoir?.composition)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.devoir.composition.filiereNiveauMatiere?.matiere?.libelle), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.devoir.composition.filiereNiveauMatiere?.filiere?.libelle), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _hoisted_36,
                              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.devoir.composition.filiereNiveauMatiere?.niveau?.libelle), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("span", null, _toDisplayString(_ctx.devoir?.fichierNom), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewCurrentFile && _ctx.viewCurrentFile(...args))),
                        class: "btn-file-action btn-view-file"
                      }, [
                        _hoisted_44,
                        _createTextVNode(" Voir le fichier ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("div", {
                    class: _normalizeClass(["upload-area", { 'has-file': _ctx.selectedFile }]),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                  }, [
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileInput",
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                      accept: ".pdf",
                      style: {"display":"none"}
                    }, null, 544),
                    (!_ctx.selectedFile)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_52))
                      : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("p", _hoisted_55, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.selectedFile.name), 1)
                          ]),
                          _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.formatFileSize(_ctx.selectedFile.size)), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-danger mt-2",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)), ["stop"]))
                          }, [
                            _hoisted_57,
                            _createTextVNode(" Supprimer ")
                          ])
                        ]))
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("button", {
                    class: "btn-action-primary",
                    type: "submit",
                    disabled: _ctx.isSubmitting || !_ctx.selectedFile || !_ctx.canModify
                  }, [
                    (_ctx.isSubmitting)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_60))
                      : (_openBlock(), _createElementBlock("i", _hoisted_61)),
                    _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Modification en cours...' : 'Enregistrer les modifications'), 1)
                  ], 8, _hoisted_59),
                  _createVNode(_component_router_link, {
                    to: "/mes-devoirs",
                    class: "btn-action-secondary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_62,
                      _createTextVNode(" Annuler ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ])),
    (!_ctx.isLoading && !_ctx.canModify)
      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.modifyCheckMessage || 'Ce devoir ne peut plus être modifié car il a déjà été corrigé.'), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPdfModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "modal-overlay",
          onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("h5", _hoisted_71, [
                  _hoisted_72,
                  _createTextVNode(_toDisplayString(_ctx.currentPdfTitle), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close-modal",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)))
                }, _hoisted_74)
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("iframe", {
                  src: _ctx.currentPdfUrl,
                  class: "pdf-iframe",
                  title: "Visualiseur PDF"
                }, null, 8, _hoisted_76)
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("a", {
                  href: _ctx.currentPdfUrl,
                  target: "_blank",
                  class: "btn-modal-action"
                }, [
                  _hoisted_79,
                  _createTextVNode(" Ouvrir dans un nouvel onglet ")
                ], 8, _hoisted_78),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-modal-secondary",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)))
                }, "Fermer")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}